export const INIT = 'app/DonationPage/INIT';
export const INIT_SUCCESS = 'app/DonationPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DonationPage/INIT_FAILED';
